import React from "react";
import {Stack} from "@mui/material";
import {SearchBox} from "../../../../../Components/Elements/SearchBox";
import {useSelector} from "react-redux";
import {setConfig} from "../../index";

export const TableActions = () => {

    const filters = useSelector((store) => store.departments?.config?.filters);

    return (
        <Stack direction="row">
            <SearchBox
                type="employee"
                placeholder="Search"
                filters={{...filters, page:0}}
                setConfig={setConfig}
            />
            {/* <CardMenu /> */}
        </Stack>
    );
}